<template>
  <section class="address">
    <ServerDisconnectConfirm
      v-if="disconnectConfirm.opened"
      :server-name="srvr.name"
      :loading="disconnectConfirm.loading"
      @approve="onDisconnectConfirm"
      @close="onDisconnectClose"
    />
    <ServerPopup
      v-if="serverPopup.opened"
      v-model="serverPopup.modelValue"
      :mode="serverPopup.mode"
      @close="onServerPopupClose"
      @approve="onServerPopupApprove"
    />
    <Header class="address__header">
      <template v-slot:title>Сервер {{ srvr.name }}</template>
      <template v-slot:addons>
        <Chips :chips="serverChips" />
        <span v-if="serverCheckedAt" class="checked-at">
          Проверено: {{ serverCheckedAt }}
        </span>
      </template>
    </Header>

    <BackButton router-page-name="MeterConfigs" class="address__back">
      Назад
    </BackButton>
    <Header class="address__subheader" type="h4">
      <template v-slot:title> Адреса </template>
    </Header>
    <div class="address__filters">
      <Filters
        :model-value="filtersActive"
        :filters="filters"
        @update:modelValue="onFiltersChange"
      />
    </div>
    <div class="address__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :selectable="false"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="currentPage"
        v-bind="pagination"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Header from '../../components/Header.vue'
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MeterConfigServer from '../../mixins/Mock/MeterConfigServer.js'
import IconBase from '../../components/Icons/IconBase.vue'
import Chips from '../../components/Chips.vue'
import ServerPopup from '../Popup/Server.vue'
import ServerDisconnectConfirm from '../Popup/ServerDisconnectConfirm.vue'
import MockPagination from '../../mixins/Mock/MockPagination.js'
import Pagination from '../../components/Pagination.vue'
import BackButton from '../../components/BackButton.vue'
import Select from '../../components/Form/Select.vue'
import Popup from '../../components/Popup.vue'

export default {
  name: 'AddressList',
  mixins: [MeterConfigServer, MockPagination],
  components: {
    Header,
    Filters,
    Table,
    Actions,
    IconBase,
    Chips,
    ServerPopup,
    ServerDisconnectConfirm,
    Pagination,
    BackButton,
    Select,
    Popup,
  },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
      disconnectConfirm: {
        opened: false,
        loading: false,
      },
    }
  },
  methods: {
    openDisconnectModal() {
      this.disconnectConfirm.opened = true
    },
    onDisconnectClose() {
      this.disconnectConfirm.opened = false
    },
    onDisconnectConfirm() {
      this.disconnectConfirm.loading = true
      this.serverService
        .removeServers([this.$route.params.serverId])
        .then(() => {
          this.disconnectConfirm.opened = false
          this.disconnectConfirm.loading = false
          this.$router.push({ name: 'MeterConfigs' })
        })
        .catch(error => {
          console.log(error)
          this.disconnectConfirm.loading = false
        })
    },
    onRowClick() {},
    onFiltersChange(value) {
      this.filtersActive = value
      const filters = Object.fromEntries(
        Object.entries(value).filter(
          ([, v]) => v !== null && v !== undefined && v !== ''
        )
      )
      this.filterUnits(filters)
    },
  },
}
</script>

<style lang="scss" scoped>
.address {
  width: 100%;

  &__header,
  &__filters,
  &__back,
  &__list {
    margin: 0px $space-md $space-lg;
  }

  &__subheader {
    margin: $space-xl $space-md $space-lg;
  }
}

.checked-at {
  color: $color-grey;
  font-size: $font-size-md;
  line-height: 20px;
}
</style>
